import React from 'react'

function Second() {
  return (
    <section className="second">
    <div className="container">
        <div className="inner-wrapper d-flex align-items-center justify-content-between mb-5">
            <div className="left-col">
                <p className="text">
                    Dette sosiale kasinospillet er designet for både nye og erfarne spillere. Spillet inneholder engasjerende elementer og gir en underholdende opplevelse med flotte visuelle effekter og dynamisk lyd. Crazy Monkey Slot handler ikke bare om spill – det tilbyr en sosial og interaktiv opplevelse som holder deg engasjert.
                </p>
            </div>
            <div className="right-col">
                <img src="/2_(2).jpg" alt="Spillet Crazy Monkey Slot"/>
            </div>
        </div>
        <p className="text text-md">
            Med et attraktivt design og en livlig atmosfære gir spillet en virtuell underholdningsopplevelse hvor hver spiller kan nyte morsomt og avslappende gameplay. Crazy Monkey Slot tilbyr en engasjerende spillopplevelse i et gratis og sosialt miljø, med ulike interaktive funksjoner som gjør hver runde unik og spennende.
        </p>
    </div>
</section>

  )
}

export default Second